import React, { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { utils } from '../utils/common';

interface AppPageProps {
    className?: string;
    header?: ReactNode;
    content?: ReactNode;
    footer?: ReactNode;
    headerClassName?: string;
    contentClassName?: string;
    footerClassName?: string;
    contentScrollable?: boolean;
    children?: ReactNode;
}

export const AppPage: React.FC<AppPageProps> = observer((props: AppPageProps) => {

    return (
        <div className={utils.className([
            ["app-page"],
            [props.className],
        ])}>
            {props.header && (
                <div className={utils.className([
                    ["app-page-header"],
                    [props.headerClassName],
                ])}>
                    {props.header}
                </div>
            )}

            {(props.content || props.children) && (
                //px-5 flex-1 py-2
                <div className={utils.className([
                    [props.contentScrollable, 'flex-1', 'app-page-content-center'],
                    [props.contentClassName],
                ])}>
                    {props.content}
                    {props.children}
                </div>
            )}

            {props.footer && (
                <div className={utils.className([
                    ["app-page-footer"],
                    [props.footerClassName],
                ])}>
                    {props.footer}
                </div>
            )}
        </div>
    );
});
